import { SafetyGauge } from './SafetyGauge';
import { CheckCircle } from '../../../../icons';

export function SafetyScoreCard({ score, flaggedCount }: { score: number; flaggedCount: number }) {
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #E5E5E5',
        borderRadius: 16,
        padding: 24,
        width: 283,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 24,
      }}
    >
      <div style={{ fontSize: 20, fontWeight: 500, color: '#0A0A0A' }}>Safety Score</div>
      <SafetyGauge score={score} />
      <div
        style={{
          alignSelf: 'stretch',
          background: '#FAFAF8',
          border: '1px solid #F5F5F5',
          borderRadius: 100,
          padding: '6px 12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 4,
        }}
      >
        <CheckCircle size={16} color="#047857" />
        <span style={{ fontSize: 14, fontWeight: 400, color: '#404040' }}>
          {flaggedCount} risk categor{flaggedCount === 1 ? 'y' : 'ies'} flagged
        </span>
      </div>
    </div>
  );
}
